export const yandexMetrikaId = 97487684

export const metrikaInit = () => {
  //@ts-ignore
  ym(yandexMetrikaId, 'init', {
    clickmap: true,
    referrer: document.referrer,
    url: location.href,
    accurateTrackBounce: true,
    trackLinks: true,
  })

  //@ts-ignore
  window.dataLayer = window.dataLayer || []
  function gtag() {
    //@ts-ignore
    dataLayer.push(arguments)
  }
  //@ts-ignore
  gtag('js', new Date())

  //@ts-ignore
  gtag('config', 'G-GL3ZJK2KHM')

  //@ts-ignore
  window.gtag = gtag
}
